import { useMemo } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";

export function useRouter() {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    for (const [key, value] of Object.entries(params)) {
      if (value) searchParams.append(key, value);
    }

    return {
      navigate,
      pathname: location.pathname,
      query: Object.fromEntries(searchParams.entries()),
    };
  }, [params, location, navigate]);
}
